import React, { useState } from "react";

import Helmet from "react-helmet";
import SEO from "../components/SEO";
import Layout from "../layouts/index";
import HomeIntro from "../components/indexPage/HomeIntro";
import HomeServices from "../components/indexPage/HomeServices";
import HomeConsulting from "../components/indexPage/HomeConsulting";
import HomeMap from "../components/indexPage/HomeMap";
import Partners from "../components/indexPage/Partners";
import ContactUs from "../components/indexPage/ContactUs";
import HomeBanner from "../components/homePage/banner";
import { Container } from "reactstrap";
import Services from "../images/user-centric-optimized.jpg";
import Sfsolution from "../components/homePage/sfsolution";
import ServiceCard from "../components/ServiceCard";
import TrustedClients from "../components/TrustedClients";
import TabcmpSet from "../components/tab/TabcmpSet";
import GetInTouchbtn from "../components/GetInTouchbtn";
import SvgIconsSet from "../components/SvgIconsSet";
import OurPartners from "../components/OurPartners";
import OurMission from "../components/OurMission";
import HowWeWorks from "../components/homePage/HowWeWorks";
import WhatOurCustomerSays from "../components/homePage/WhatOurCustomerSays";
import NewAccordion from "../components/NewAccordion";
import Resources from "../components/homePage/Resources";
import Impact from "../components/homePage/Impact";
import StrategyDesign from "../images/strategy-and-design.jpg";
import BuildEngineer from "../images/build-and-engineer.jpg";
import ServicesResources from "../images/services-and-resources.jpg";

const Home = () => {
  const tabData = [
    { label: "Energy", content: <TrustedClients /> },
    { label: "FinTech", content: <TrustedClients /> },
    { label: "Banking", content: <TrustedClients /> },
    { label: "Telco", content: <TrustedClients /> },
    { label: "Health", content: <TrustedClients /> },
  ];

  //faqs
  const [items, setItems] = useState([]);
  const faqData = [
    {
      id: 1,
      heading: "How long does a web design project take?",
      content:
        "Lorem ipsum dolor sit amet, consectetur cdolor col adipiscing elit. Integer mattis nunc augue vel lacinia erat euismod ut. Sed eleifend tellus nonole tincidunt aliquet. Fusce aliquam mi felis.",
    },
    {
      id: 2,
      heading: "What factors affect the cost of web design?",
      content:
        "Lorem ipsum dolor sit amet, consectetur cdolor col adipiscing elit. Integer mattis nunc augue vel lacinia erat euismod ut. Sed eleifend tellus nonole tincidunt aliquet. Fusce aliquam mi felis.",
    },

    {
      id: 1,
      heading: "Do you provide ongoing support?",
      content:
        "Lorem ipsum dolor sit amet, consectetur cdolor col adipiscing elit. Integer mattis nunc augue vel lacinia erat euismod ut. Sed eleifend tellus nonole tincidunt aliquet. Fusce aliquam mi felis.",
    },
    {
      id: 2,
      heading: "What is your web design process?",
      content:
        "Lorem ipsum dolor sit amet, consectetur cdolor col adipiscing elit. Integer mattis nunc augue vel lacinia erat euismod ut. Sed eleifend tellus nonole tincidunt aliquet. Fusce aliquam mi felis.",
    },
  ];

  useState(() => {
    setItems(faqData);
  }, []);

  return (
    <Layout bodyClass="page-index">
      <SEO title="Home" />
      <Helmet>
        <meta
          name="description"
          content="Innovation Partner - IoT, Mobile Apps &amp; Software Development, Cloud Engineering | iTelaSoft"
        />
      </Helmet>

      {/* home banner */}

      <HomeBanner />

      <Container>
        <div className="section-padding" id="Sfsolution">
          <section>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h2 className="title-1 mb-2">Agile, innovative and impactful software engineering solutions</h2>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <ServiceCard
                    image={StrategyDesign}
                    title="Strategy & Design"
                    description="We take you from ideation to delivery and beyond"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <ServiceCard
                    image={BuildEngineer}
                    title="Build & Engineer"
                    description="If you dream it, we can build it"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <ServiceCard
                    image={ServicesResources}
                    title="Managed Services & Resources"
                    description="Create capacity and efficiency in your business"
                  />
                </div>
                <div className="col-12">
                  <p className="my-2">Our extensive team of software engineers, designers and developers gives you access to the right skills and experience needed to deliver real business impact and cost efficiencies. Smart design, agile delivery and vendor management is in our DNA, ensuring exceptional outcomes 
  for you - every time.</p>
                  <a href="/services" class="btn btn-primary btn-icon-button">
                    <span className="btn-text">Learn more</span>
                    <span className="btn-icon">
                      <SvgIconsSet.SideArrow />
                    </span>
                  </a>
                </div>
              </div>              
            </div>
          </section>
        </div>

        <div className="section-padding mt-4" id="section-who-we-works-with">
          <div className="section-who-we-works-with-top">
            <h3 className="title-1">Who we work with</h3>
            <div className="section-discription">
              We work with businesses of all sizes including Startup/Scaleups,
              Mid-size businesses and Large Enterprises across the globe. Our
              solutions can be adapted for just about any industry, and to date,
              some of the companies we've worked with include:
            </div>
          </div>
          <Partners />
          {/* <div className="wr-tabcmpset">
            <TabcmpSet tabData={tabData} />
          </div> */}
          <div className="home-getting-touch">
            <div className="getting-touch">
              <GetInTouchbtn textdce={"Let’s talk!"} />
            </div>
          </div>
        </div>
        <div className="section-padding">
          <OurPartners />
        </div>

        <div className="section-padding">
          <OurMission />
        </div>

        
      </Container>
      
      <section className="mt-3 pb-3" style={{background: "#efefef"}}>
        <Container>
        <div className="section-padding">
          <HowWeWorks />
        </div>
        </Container>
      </section>

      <Container>

        <div className="section-padding">
          <WhatOurCustomerSays />
        </div>

        {/* <div className="section-padding section-faq">
          <div className="title-1 mb-2">Frequently Asked Questions</div>
          <NewAccordion items={items} />
        </div> */}

        {/* <div className="section-padding">
          <div className="title-1 mb-2">Resources</div>
          <Resources />
        </div> */}
        <div className="section-padding pb-4">
          <Impact />
        </div>
      </Container>
    </Layout>
  );
};

export default Home;
